import SectionHeading from "@/components/SectionHeading";
import { useContent } from "@/context/ContentContext";
import { imgSrc } from "@/lib/api";
import SEO from "@/components/SEO";

export default function Projects() {
  const { projects } = useContent();
  return (
    <div data-testid="projects-page" className="pt-32 pb-24">
      <SEO path="/projects" title="Aluminium & ACP Projects Across India"
        description="Projects supplied by Victory Aluminium — commercial towers, luxury villa communities, corporate interiors, retail showrooms, industrial facades. Aluminium and ACP supply for landmark Indian developments." />
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 mb-14">
        <SectionHeading eyebrow="Projects & Applications" title="Built into landmarks across India."
          sub="A sample of the residential, commercial, interior, and industrial projects we have supplied — from single villas to multi-tower developments." />
      </section>
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((p) => (
            <article key={p.id} data-testid={`project-card-${p.id}`} className="group relative overflow-hidden bg-[#1A1A1A] aspect-[4/5]">
              <img src={imgSrc(p.image)} alt={p.title} className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:scale-105 group-hover:opacity-100 transition-all duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent"></div>
              <div className="relative z-10 h-full flex flex-col justify-end p-6 text-white">
                <span className="tracking-eyebrow text-[#D4AF37]">{p.tag}</span>
                <h3 className="font-display text-xl md:text-2xl mt-2 leading-tight">{p.title}</h3>
                <span className="text-xs text-[#D1D5DB] mt-1">{p.city}</span>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
